import React, {useEffect, useState} from 'react';
import {isEmpty} from 'lodash';
import {safeGtag} from "../Analytics/googleAnalyticsFour";
import {buildGA4OrderEvent} from "../Analytics/googleOrderAdapter";

// https://developers.google.com/analytics/devguides/collection/ga4/reference/events?client_type=gtag#purchase

const isDev = (process.env.NODE_ENV == 'development');

export default function ReportOrderToGoogleAnalytics4({
  order, orderedItems, groupCollection, debugReporting = false,
  ...props
}) {
  const [reported, setReported] = useState(null);

  useEffect(() => {
    if (reported || !order || _.isEmpty(orderedItems)) return;

    let event = buildGA4OrderEvent({
      order, orderedItems, groupCollection
    });

    // inhibit reporting it again
    setReported(event)

    // report to google
    safeGtag(...event);
  }, [order, reported]);

  if (isDev || debugReporting) {
    return <pre className="text-teal-400 bg-red-200" >
    {JSON.stringify(reported, null, 2)}
  </pre>
  }

  return null;
}
